// import { Redirect } from "react-router-dom"
import { all, call, fork, put, takeEvery } from "redux-saga/effects"
import { getOrdersApi } from "../../Service/Api/OrdersListApi"
import { getOrdersList,getErrors } from "../Reducer/OrderListReducer"



// Watchers
function* ordersListSaga() {
	yield takeEvery("order_list/getOrders", getAllOrders)
}

// Sagas
function* getAllOrders(action) {
    // console.log(action)
	try {
        const getOrdersData = yield call(getOrdersApi, action.payload)
        // console.log(getProducts,"ldfgsdgb")

		if (getOrdersData.request.status === 200) {
			yield put(getOrdersList(getOrdersData))
		} else {
			yield put(getErrors(true))
		}
	} catch (error) {
		// console.log(error,"otp error")
		yield put(getErrors(error))
	}
}

export default function* rootSaga() {
	yield all([fork(ordersListSaga)])
}
